import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

const statusStyles = {
  Proposal: { backgroundColor: "#fff3cd", color: "#856404" },
  StartUp: { backgroundColor: "#d2efff", color: "#007bff" },
  OnHold: { backgroundColor: "#fff3cd", color: "#856404" },
  OnGoing: { backgroundColor: "#e4e9f1", color: "#3c4b64" },
  Recruiting: { backgroundColor: "#fff3cd", color: "#856404" },
  Discarded: { backgroundColor: "#ffe3e9", color: "#d6336c" },
  Closed: { backgroundColor: "#ffe3e9", color: "#d6336c" },
};

const TrialStatusChip = ({ status }) => {
  const { t } = useTranslation();
  const style = statusStyles[status] || statusStyles["Proposal"];
  const labelMap = {
    Proposal: t("clinicalTrials.statuses.Proposal"),
    StartUp: t("clinicalTrials.statuses.StartUp"),
    OnHold: t("clinicalTrials.statuses.OnHold"),
    OnGoing: t("clinicalTrials.statuses.OnGoing"),
    Recruiting: t("clinicalTrials.statuses.Recruiting"),
    Discarded: t("clinicalTrials.statuses.Discarded"),
    Closed: t("clinicalTrials.statuses.Closed"),
  };

  return (
    <span
      style={{
        padding: "6px 12px",
        borderRadius: "20px",
        fontWeight: "bold",
        fontSize: "14px",
        display: "inline-flex",
        alignItems: "center",
        ...style,
      }}
    >
      {labelMap[status]}
      <span
        style={{
          width: "8px",
          height: "8px",
          backgroundColor: style.color,
          borderRadius: "50%",
          marginLeft: "8px",
        }}
      />
    </span>
  );
};

TrialStatusChip.propTypes = {
  status: PropTypes.oneOf([
    "Proposal",
    "StartUp",
    "OnHold",
    "OnGoing",
    "Recruiting",
    "Discarded",
    "Closed",
  ]).isRequired,
};

export default TrialStatusChip;
